/**
 * Created by JIocb on 20.06.2017.
 */

namespace Factive.Game {
    import Signal = Factive.Core.Signal.Signal;
    export class UserBagModel
    {
        private _bag: Array<DiceData> = [];
        private _dices: Array<DiceData> = [];
        public signal:Signal;
        private _lock: boolean = false;

        public constructor()
        {
            this.signal = new Signal();
        }

        public addToBag(dice:DiceData):void
        {
            this._dices[this._dices.length] = dice;

            var slot = this.findEmptySlot();
            this._bag[slot] = dice;

            this.onUpdate();
        };

        private findSlotbyDice(dice:DiceData):number
        {
            for(var i:number = 0; i<5; i++)
            {
                if(this._bag[i] != null
                    && this._bag[i].id == dice.id
                    && this._bag[i].value == dice.value
                    && this._bag[i].color == dice.color
                )
                {
                    return i;
                }
            }
            return -1;
        };

        private findEmptySlot():number
        {
            if(this._bag.length == 0)
                return 0;

            for(var i:number = 0; i<5; i++)
            {
                if(this._bag[i] == null)
                {
                    return i;
                }
            }
            return -1;
        }


        public getDices():Array<DiceData>
        {
            return this._dices;
        }

        public getBag():Array<DiceData>
        {
            return this._bag;
        }


        public getBagDicesIds():Array<number>
        {
            var result:Array<number> = [];

            var l:number = this._dices.length;
            for(var i:number = 0; i<l; i++)
            {
                result[i] = this._dices[i].id;
            }
            return result;
        }

        private _history:any = {}

        public clearTheBag():void
        {
            //console.log("clearTheBag");
            this._history.bag = this._bag.slice();
            this._history.dices = this._dices.slice();
            this._bag.length = 0;
            this._dices.length = 0;

            this.onUpdate();
        }

        public undo():void
        {
            //console.log("undo bag");
            this._bag = this._history.bag.slice();
            this._dices = this._history.dices.slice();

            this._history.bag = null;
            this._history.dices = null;
            this._history.frozenSlots = null;

            this.onUpdate();
        }

        public removeFromBagBySlotIndex(slot: number):DiceData
        {
            var dice:DiceData = this._bag[slot];
            this.removeFromBag(dice);
            return dice;
        }

        public removeFromBag(dice: DiceData):void
        {

            for(var i:number = 0; i<5; i++)
            {
                var d:DiceData = this._bag[i]
                if( d != null && d.id == dice.id && d.value == dice.value && d.color == dice.color)
                {
                    this._bag[i] = null;
                    break;
                }
            }

            for(var i:number = 0; i<5; i++)
            {
                if(this._dices[i] != null
                    && this._dices[i].id == dice.id
                    && this._dices[i].value == dice.value
                    && this._dices[i].color == dice.color
                )
                {
                    this._dices.splice(i,1);
                    break;
                }
            }

            this.onUpdate();
        }

        public lock(value:boolean):void
        {
            this._lock = value;

            this.onUpdate();
        };

        public get isLocked():boolean
        {
            return this._lock;
        }

        private onUpdate() {
            this.signal.dispatch("update");
        };
    }
}


// WEBPACK FOOTER //
// src/typescript/Game/Engine/Model/User/UserBagModel.ts